import { DeliveryMethodDtoType } from '@ordr-as/ordr-service-types/epos';
import { useLocation } from '../context/LocationContext';
import { useActiveDigitalBill } from '../context/DigitalBillStore';

const useDeliveryMethod = (vatType: 'EAT_IN' | 'TAKEAWAY', tableNumber?: string) => {
  const {
    location: { deliveryMethods },
  } = useLocation();
  const activeDigitalBill = useActiveDigitalBill();

  /**
   * Combinations that should be allowed:
   * - EAT_IN + TABLE_NUMBER
   * - EAT_IN = COUNTER
   * - TAKEAWAY + activeDigitalBill
   * - TAKEAWAY
   * - COUNTER + activeDigitalBill
   * - PICKUP is the same as counter
   */

  const takeaway = deliveryMethods.find((d) => d.type === DeliveryMethodDtoType.TAKEAWAY);
  const table = deliveryMethods.find((d) => d.type === DeliveryMethodDtoType.TABLE);
  const counter = deliveryMethods.find((d) => d.type === DeliveryMethodDtoType.COUNTER);

  if (!counter) {
    throw new Error('No counter found for epos location');
  }

  if (vatType === 'TAKEAWAY') {
    if (!takeaway) {
      throw new Error('No takeaway delivery method found, but vatType is TAKEAWAY');
    }
    return takeaway;
  }

  if (tableNumber) {
    if (!table) {
      throw new Error('No table delivery method found, but table number is present');
    }
    return table;
  }

  if (activeDigitalBill) {
    return table ?? counter;
  }

  return counter;
};

export default useDeliveryMethod;
